import React from 'react';
import { SvgProps } from './icon.types';

function EyeSlashIcon({ title, fillColor = '#2D3049', ...props }: SvgProps) {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M3.86 2.5l2.16 2.16c.9-.42 1.91-.7 2.98-.7 4.19 0 7.43 4.28 7.57 4.47L17 9l-.5.66c-.27.35-1.3 1.6-2.8 2.67l1.8 1.79-1.37 1.37-2.15-2.15c-.91.42-1.91.7-2.98.7-4.19 0-7.43-4.28-7.57-4.46L1 9l.54-.72c.32-.4 1.32-1.59 2.75-2.61l-1.8-1.8L3.85 2.5zM3.48 9l.22.24c1.02 1.09 3.06 2.87 5.3 2.87.5 0 1-.1 1.48-.25l-.6-.6a2.43 2.43 0 01-3.14-3.14L5.68 7.06A12.3 12.3 0 003.48 9zM9 5.9c-.51 0-1.01.1-1.49.25l.6.6a2.43 2.43 0 013.14 3.14l1.06 1.06c.96-.65 1.74-1.43 2.21-1.94l-.22-.24C13.27 7.68 11.24 5.9 9 5.9z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { EyeSlashIcon };
